import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import {
  Container,
  Card,
  Table,
  Form,
  Button,
  Row,
  Col,
  Alert,
  Modal,
} from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import "../styles/workhour.css";
import moment from "jalali-moment";
import api from "../api.js";
import DateObject from "react-date-object";

export default function WorkHours() {
  const [workHours, setWorkHours] = useState([]);
  const [form, setForm] = useState({
    title: "",
    custom_title: "",
    description: "",
    presence: "on-site",
    date: "",
    duration_hour: "",
    duration_min: "",
    start_hour: "",
    start_min: "",
    end_hour: "",
    end_min: "",
    report_count: "",
    scoring_report_count: "",
  });
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);

  // Edit modal states
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState(null);
  const [editSelectedDate, setEditSelectedDate] = useState(null);
  const [editing, setEditing] = useState(false);

  const titleSuggestions = [
    "گزارش فناوری",
    "امتیازدهی فناوری",
    "گزارش تجمیعی",
    "بارگزاری در سایت",
    " گزارش فصلی",
    "اصلاح گزارش تجمیعی",
    "آموزش",
    "سایر",
  ];

  const token = Cookies.get("access_token");

  useEffect(() => {
    fetchWorkHours();
    fetchMonthlySummary();
    // eslint-disable-next-line
  }, []);

  const fetchWorkHours = async () => {
    try {
      const res = await api.get("/workhours/", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setWorkHours(res.data);
    } catch (err) {
      console.error("Error fetching work hours:", err);
    }
  };

  const fetchMonthlySummary = async () => {
    try {
      const today = new DatePicker({ calendar: persian, locale: persian_fa }).toDateObject();
      const jYear = today.year;
      const jMonth = today.month.number;

      const res = await api.get(
        `/workhours/summary/?year=${jYear}&month=${jMonth}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSummary(res.data);
    } catch (err) {
      console.error("Error fetching monthly summary:", err);
    }
  };

  const handleDateChange = (dateObj) => {
  setSelectedDate(dateObj);

  if (dateObj && dateObj.isValid) {
    const gregorianDate = dateObj
      .convert(gregorian)
      .format("YYYY-MM-DD");

    setForm((prev) => ({
      ...prev,
      date: gregorianDate,
    }));
  } else {
    setForm((prev) => ({
      ...prev,
      date: "",
    }));
  }
};

  // ---------------- Create submit ----------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");

    const finalTitle = form.title === "سایر" ? form.custom_title : form.title;

    try {
      const payload = {
        ...form,
        title: finalTitle,
      };
      if (!form.date) {
  setMsg("❌ لطفا تاریخ را انتخاب کنید.");
  setLoading(false);
  return;
}

      // attach start_time/end_time only if presence is on-site and hours provided
      if (form.presence === "on-site") {
        if (form.start_hour !== "" && form.start_min !== "") {
          payload.start_time = `${String(form.start_hour).padStart(2, "0")}:${String(form.start_min).padStart(2, "0")}:00`;
        }
        if (form.end_hour !== "" && form.end_min !== "") {
          payload.end_time = `${String(form.end_hour).padStart(2, "0")}:${String(form.end_min).padStart(2, "0")}:00`;
        }
      } else {
        delete payload.start_time;
        delete payload.end_time;
      }

      if (form.title !== "گزارش فناوری") delete payload.report_count;
      if (form.title !== "امتیازدهی فناوری") delete payload.scoring_report_count;

      // convert duration strings to numbers if present
      if (payload.duration_hour === "") payload.duration_hour = 0;
      if (payload.duration_min === "") payload.duration_min = 0;
      // --- آموزش: نصف کردن زمان ---
      if (form.title === "آموزش") {
        let h = Number(payload.duration_hour) || 0;
        let m = Number(payload.duration_min) || 0;

        // Convert to minutes
        let totalMin = h * 60 + m;

        // Half duration
        totalMin = Math.floor(totalMin / 2);

        // Convert back
        payload.duration_hour = Math.floor(totalMin / 60);
        payload.duration_min = totalMin % 60;
      }


      await api.post("/workhours/", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMsg("✅ ساعت کاری با موفقیت ثبت شد!");
      setForm({
        title: "",
        custom_title: "",
        description: "",
        presence: "on-site",
        date: "",
        duration_hour: "",
        duration_min: "",
        start_hour: "",
        start_min: "",
        end_hour: "",
        end_min: "",
        report_count: "",
        scoring_report_count: "",
      });
      setSelectedDate(null);
      fetchWorkHours();
      fetchMonthlySummary();
    } catch (err) {
      console.error("Error creating work hour:", err);
      setMsg("❌ خطا در ذخیره ساعت کاری.");
    }
    setLoading(false);
  };

  // ---------------- Delete ----------------
  const handleDelete = async (id) => {
    if (!window.confirm("آیا از حذف این ساعت کاری اطمینان دارید؟")) return;

    try {
      await api.delete(`/workhours/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMsg("🗑️ ساعت کاری حذف شد!");
      setWorkHours((prev) => prev.filter((w) => w.id !== id));
      fetchMonthlySummary();
    } catch (err) {
      console.error("Error deleting work hour:", err);
      setMsg("❌ خطا در حذف ساعت کاری.");
    }
  };

  // ---------------- Edit handlers ----------------
  const openEditModal = (work) => {
    // prefill edit form with work data
    const splitStart = work.start_time ? work.start_time.split(":") : ["", ""];
    const splitEnd = work.end_time ? work.end_time.split(":") : ["", ""];
    const prefill = {
      id: work.id,
      title: work.title,
      custom_title: "",
      description: work.description || "",
      presence: work.presence || "on-site",
      date: work.date || "",
      duration_hour: work.duration_hour ?? "",
      duration_min: work.duration_min ?? "",
      start_hour: splitStart[0] || "",
      start_min: splitStart[1] || "",
      end_hour: splitEnd[0] || "",
      end_min: splitEnd[1] || "",
      report_count: work.report_count ?? "",
      scoring_report_count: work.scoring_report_count ?? "",
    };

    setEditForm(prefill);

    // set datepicker value as JS Date (DatePicker accepts Date)
    setEditSelectedDate(
  work.date
    ? new DateObject({
        date: work.date,
        calendar: gregorian,
      }).convert(persian)
    : null
);

    setShowEditModal(true);
  };

  const handleEditDateChange = (dateObj) => {
    setEditSelectedDate(dateObj);
    if (dateObj) {
      const gregorianDate = dateObj.convert(gregorian).format("YYYY-MM-DD");
      setEditForm((prev) => ({ ...prev, date: gregorianDate }));
    } else {
      setEditForm((prev) => ({ ...prev, date: "" }));
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editForm) return;
    setEditing(true);
    setMsg("");

    try {
      const finalTitle = editForm.title === "سایر" ? editForm.custom_title : editForm.title;

      const payload = {
        title: finalTitle,
        description: editForm.description,
        presence: editForm.presence,
        date: editForm.date,
        duration_hour: editForm.duration_hour === "" ? 0 : Number(editForm.duration_hour),
        duration_min: editForm.duration_min === "" ? 0 : Number(editForm.duration_min),
        report_count: editForm.report_count === "" ? 0 : Number(editForm.report_count),
        scoring_report_count: editForm.scoring_report_count === "" ? 0 : Number(editForm.scoring_report_count),
      };
      if (!editForm.date) {
  setMsg("❌ لطفا تاریخ را انتخاب کنید.");
  setEditing(false);
  return;
}

      if (editForm.presence === "on-site") {
        if (editForm.start_hour !== "" && editForm.start_min !== "") {
          payload.start_time = `${String(editForm.start_hour).padStart(2, "0")}:${String(editForm.start_min).padStart(2, "0")}:00`;
        } else {
          payload.start_time = null;
        }
        if (editForm.end_hour !== "" && editForm.end_min !== "") {
          payload.end_time = `${String(editForm.end_hour).padStart(2, "0")}:${String(editForm.end_min).padStart(2, "0")}:00`;
        } else {
          payload.end_time = null;
        }
      } else {
        payload.start_time = null;
        payload.end_time = null;
      }

      // remove irrelevant fields depending on title
      if (editForm.title !== "گزارش فناوری") delete payload.report_count;
      if (editForm.title !== "امتیازدهی فناوری") delete payload.scoring_report_count;

      // --- آموزش: نصف کردن زمان ---
      if (editForm.title === "آموزش") {
        let h = Number(payload.duration_hour) || 0;
        let m = Number(payload.duration_min) || 0;

        // Convert to minutes
        let totalMin = h * 60 + m;

        // Half duration
        totalMin = Math.floor(totalMin / 2);

        // Convert back
        payload.duration_hour = Math.floor(totalMin / 60);
        payload.duration_min = totalMin % 60;
      }

      await api.patch(`/workhours/${editForm.id}/`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMsg("✏️ تغییرات با موفقیت ذخیره شد!");
      setShowEditModal(false);
      setEditForm(null);
      setEditSelectedDate(null);
      fetchWorkHours();
      fetchMonthlySummary();
    } catch (err) {
      console.error("Error updating work hour:", err);
      setMsg("❌ خطا در ذخیره تغییرات.");
    }
    setEditing(false);
  };

  // small helper to display time nicely (HH:MM)
  const formatTimeShort = (t) => {
    if (!t) return "-";
    // t may be "HH:MM:SS"
    const parts = t.split(":");
    return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : t;
  };

  return (
    <Container className="workhour mt-5">
      <Card className="p-4 shadow-sm workhour-card">
        <h3 className="title mb-3 text-center">ثبت ساعات کاری</h3>
        {msg && (
          <Alert
            variant={
              msg.includes("✅")
                ? "success"
                : msg.includes("🗑️") || msg.includes("✏️")
                ? "warning"
                : "danger"
            }
          >
            {msg}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>عنوان فعالیت</Form.Label>
                <Form.Select
                  value={form.title}
                  onChange={(e) => {
                            const value = e.target.value;
                              setForm({...form,title : value});

                      if (value === "آموزش") {
                      alert("توجه: زمان این فعالیت به صورت خودکار نصف خواهد شد.");
                        }
                          }}

                  required
                >
                  <option value="">انتخاب کنید...</option>
                  {titleSuggestions.map((t, i) => (
                    <option key={i} value={t}>
                      {t}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {form.title === "سایر" && (
                <Form.Group className="mb-2">
                  <Form.Label>عنوان دلخواه</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="عنوان فعالیت خود را وارد کنید"
                    value={form.custom_title}
                    onChange={(e) =>
                      setForm({ ...form, custom_title: e.target.value })
                    }
                  />
                </Form.Group>
              )}

              <Form.Group className="mb-2">
                <Form.Label>محل حضور</Form.Label>
                <Form.Select
                  value={form.presence}
                  onChange={(e) => setForm({ ...form, presence: e.target.value })}
                >
                  <option value="on-site">حضوری</option>
                  <option value="remote">دورکار</option>
                </Form.Select>
              </Form.Group>

              {form.presence === "on-site" && (
                <>
                  <Form.Group className="mb-2">
                    <Form.Label>زمان شروع</Form.Label>
                    <Row>
                      <Col>
                        <Form.Control
                          type="number"
                          placeholder="ساعت"
                          value={form.start_hour}
                          onChange={(e) =>
                            setForm({ ...form, start_hour: e.target.value })
                          }
                          min="0"
                          max="23"
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          type="number"
                          placeholder="دقیقه"
                          value={form.start_min}
                          onChange={(e) =>
                            setForm({ ...form, start_min: e.target.value })
                          }
                          min="0"
                          max="59"
                        />
                      </Col>
                    </Row>
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>زمان پایان</Form.Label>
                    <Row>
                      <Col>
                        <Form.Control
                          type="number"
                          placeholder="ساعت"
                          value={form.end_hour}
                          onChange={(e) =>
                            setForm({ ...form, end_hour: e.target.value })
                          }
                          min="0"
                          max="23"
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          type="number"
                          placeholder="دقیقه"
                          value={form.end_min}
                          onChange={(e) =>
                            setForm({ ...form, end_min: e.target.value })
                          }
                          min="0"
                          max="59"
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </>
              )}
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>تاریخ</Form.Label>
                <DatePicker
                  value={selectedDate}
                  onChange={handleDateChange}
                  calendar={persian}
                  locale={persian_fa}
                  inputClass="form-control"
                  calendarPosition="bottom-right"
                  placeholder="انتخاب تاریخ"
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>زمان مفید</Form.Label>
                <Row>
                  <Col>
                    <Form.Control
                      type="number"
                      min="0"
                      value={form.duration_hour}
                      onChange={(e) =>
                        setForm({ ...form, duration_hour: e.target.value })
                      }
                      placeholder="ساعت"
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="number"
                      placeholder="دقیقه"
                      min="0"
                      max="59"
                      value={form.duration_min}
                      onChange={(e) =>
                        setForm({ ...form, duration_min: e.target.value })
                      }
                    />
                  </Col>
                </Row>
              </Form.Group>

              {/* Conditional fields */}
              {form.title === "گزارش فناوری" && (
                <Form.Group className="mb-2">
                  <Form.Label>تعداد گزارش‌ها</Form.Label>
                  <Form.Control
                    type="number"
                    required
                    min="0"
                    value={form.report_count}
                    onChange={(e) =>
                      setForm({ ...form, report_count: e.target.value })
                    }
                    placeholder="مثلاً 5"
                  />
                </Form.Group>
              )}

              {form.title === "امتیازدهی فناوری" && (
                <Form.Group className="mb-2">
                  <Form.Label>تعداد گزارش امتیازدهی‌ شده</Form.Label>
                  <Form.Control
                    type="number"
                    required
                    min="0"
                    value={form.scoring_report_count}
                    onChange={(e) =>
                      setForm({ ...form, scoring_report_count: e.target.value })
                    }
                    placeholder="مثلاً 3"
                  />
                </Form.Group>
              )}

              <Form.Group className="mb-2">
                <Form.Label>توضیحات</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={form.description}
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                />
              </Form.Group>

              <Button
                type="submit"
                variant="primary"
                className="mt-4 w-100"
                disabled={loading}
              >
                {loading ? "در حال ذخیره..." : "افزودن ساعت کاری"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>

      {summary && (
        <Alert className="mt-3" variant="info">
          <strong>مجموع ماه جاری:</strong> {summary.formatted} (
          {summary.year}/{summary.month})
        </Alert>
      )}

      <Card className="mt-5 p-3 shadow-sm mb-3">
        <h5>ساعات کاری اخیر</h5>
        <Table striped hover responsive className="mt-2 text-center">
          <thead>
            <tr>
              <th>تاریخ</th>
              <th>عنوان</th>
              <th>محل</th>
              <th>زمان مفید</th>
              <th>شروع</th>
              <th>پایان</th>
              <th>توضیحات</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {workHours.map((w) => (
              <tr key={w.id}>
                <td>
                  {moment(w.date, "YYYY-MM-DD")
                    .locale("fa")
                    .format("jYYYY/jMM/jDD")
                    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])}
                </td>
                <td>{w.title}</td>
                <td>{w.presence === "on-site" ? "حضوری" : "دورکار"}</td>
                <td>
                  {w.duration_hour}س {w.duration_min}د
                </td>
                <td>{formatTimeShort(w.start_time)}</td>
                <td>{formatTimeShort(w.end_time)}</td>
                <td>{w.description || "-"}</td>
                <td>
                  <div className="d-flex justify-content-center gap-2">
                    <Button
                    className="btn-edit"
                      variant="outline-primary"
                      size="sm"
                      onClick={() => openEditModal(w)}
                    >
                      ویرایش
                    </Button>
                    <Button
                    className="btn-delete"
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete(w.id)}
                    >
                      حذف
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>ویرایش ساعت کاری</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editForm ? (
            <Form onSubmit={handleEditSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label>عنوان فعالیت</Form.Label>
                    <Form.Select
                      value={editForm.title}
                      onChange={(e) => {
                          const value = e.target.value;
                        setEditForm({ ...editForm, title: value });

                            if (value === "آموزش") {
                              alert("توجه: زمان این فعالیت به صورت خودکار نصف خواهد شد.");
                                  }
                          }}

                      required
                    >
                      <option value="">انتخاب کنید...</option>
                      {titleSuggestions.map((t, i) => (
                        <option key={i} value={t}>
                          {t}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  {editForm.title === "سایر" && (
                    <Form.Group className="mb-2">
                      <Form.Label>عنوان دلخواه</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="عنوان فعالیت خود را وارد کنید"
                        value={editForm.custom_title}
                        onChange={(e) => setEditForm({ ...editForm, custom_title: e.target.value })}
                      />
                    </Form.Group>
                  )}

                  <Form.Group className="mb-2">
                    <Form.Label>محل حضور</Form.Label>
                    <Form.Select
                      value={editForm.presence}
                      onChange={(e) => setEditForm({ ...editForm, presence: e.target.value })}
                    >
                      <option value="on-site">حضوری</option>
                      <option value="remote">دورکار</option>
                    </Form.Select>
                  </Form.Group>

                  {editForm.presence === "on-site" && (
                    <>
                      <Form.Group className="mb-2">
                        <Form.Label>زمان شروع</Form.Label>
                        <Row>
                          <Col>
                            <Form.Control
                              type="number"
                              placeholder="ساعت"
                              value={editForm.start_hour}
                              onChange={(e) => setEditForm({ ...editForm, start_hour: e.target.value })}
                              min="0"
                              max="23"
                            />
                          </Col>
                          <Col>
                            <Form.Control
                              type="number"
                              placeholder="دقیقه"
                              value={editForm.start_min}
                              onChange={(e) => setEditForm({ ...editForm, start_min: e.target.value })}
                              min="0"
                              max="59"
                            />
                          </Col>
                        </Row>
                      </Form.Group>

                      <Form.Group className="mb-2">
                        <Form.Label>زمان پایان</Form.Label>
                        <Row>
                          <Col>
                            <Form.Control
                              type="number"
                              placeholder="ساعت"
                              value={editForm.end_hour}
                              onChange={(e) => setEditForm({ ...editForm, end_hour: e.target.value })}
                              min="0"
                              max="23"
                            />
                          </Col>
                          <Col>
                            <Form.Control
                              type="number"
                              placeholder="دقیقه"
                              value={editForm.end_min}
                              onChange={(e) => setEditForm({ ...editForm, end_min: e.target.value })}
                              min="0"
                              max="59"
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </>
                  )}
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label>تاریخ</Form.Label>
                    <DatePicker
                      value={editSelectedDate}
                      onChange={handleEditDateChange}
                      calendar={persian}
                      locale={persian_fa}
                      inputClass="form-control"
                      calendarPosition="bottom-right"
                      placeholder="انتخاب تاریخ"
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>زمان مفید</Form.Label>
                    <Row>
                      <Col>
                        <Form.Control
                          type="number"
                          min="0"
                          value={editForm.duration_hour}
                          onChange={(e) => setEditForm({ ...editForm, duration_hour: e.target.value })}
                          placeholder="ساعت"
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          type="number"
                          placeholder="دقیقه"
                          min="0"
                          max="59"
                          value={editForm.duration_min}
                          onChange={(e) => setEditForm({ ...editForm, duration_min: e.target.value })}
                        />
                      </Col>
                    </Row>
                  </Form.Group>

                  {editForm.title === "گزارش فناوری" && (
                    <Form.Group className="mb-2">
                      <Form.Label>تعداد گزارش‌ها</Form.Label>
                      <Form.Control
                        type="number"
                        required
                        min="0"
                        value={editForm.report_count}
                        onChange={(e) => setEditForm({ ...editForm, report_count: e.target.value })}
                        placeholder="مثلاً 5"
                      />
                    </Form.Group>
                  )}

                  {editForm.title === "امتیازدهی فناوری" && (
                    <Form.Group className="mb-2">
                      <Form.Label>تعداد امتیازدهی‌ها</Form.Label>
                      <Form.Control
                        type="number"
                        required
                        min="0"
                        value={editForm.scoring_report_count}
                        onChange={(e) => setEditForm({ ...editForm, scoring_report_count: e.target.value })}
                        placeholder="مثلاً 3"
                      />
                    </Form.Group>
                  )}

                  <Form.Group className="mb-2">
                    <Form.Label>توضیحات</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={editForm.description}
                      onChange={(e) => setEditForm({ ...editForm, description: e.target.value })}
                    />
                  </Form.Group>

                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2 mt-3">
                <Button variant="secondary" onClick={() => setShowEditModal(false)}>انصراف</Button>
                <Button type="submit" variant="primary" disabled={editing}>
                  {editing ? "در حال ذخیره..." : "ذخیره تغییرات"}
                </Button>
              </div>
            </Form>
          ) : (
            <div>در حال بارگذاری...</div>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
}
